import React from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import ExpenseCreate from "./ExpenseCreate";
import ExpenseList from "./ExpenseList";

const ExpensePage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const activeKey = params.get("tab") || "1";

  return (
    <Tabs
      activeKey={activeKey}
      items={[
        { key: "1", label: "Зардал", children: <ExpenseCreate /> },
        {
          key: "2",
          label: "Зардлын жагсаалт",
          children: <ExpenseList />,
        },
      ]}
      onChange={(key) => {
        navigate(`/ExpensePage?tab=${key}`);
      }}
    />
  );
};

export default ExpensePage;
